export default "__VITE_ASSET__BUO0N$sA__"